import type { PickerCatalog } from './mock-catalogs'

export const filterCatalogs = (catalogs: PickerCatalog[], query: string) => {
  const q = query.trim().toLowerCase()
  if (!q) return catalogs
  return catalogs.filter(c => c.name.toLowerCase().includes(q))
}
